import { useParams, useNavigate, Navigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import MyOrder from "./MyOrder";
import MyInfo from "./MyInfo";
import MyPoint from "./MyPoint";
import MyPost from "./MyPost";
import MyGroup from "./MyGroup";
import MyExpert from "./MyExpert";
import HomeBanner from "../../banner/HomeBanner";
import UserContext from "../../../context/UserContext";
import UserApi from "../../../api/UserApi";
import Membership from "../membership/Membership";
import { resolveUserProfileImg } from "../../../util/ProfileUtil";

const TabBtn = ({ label='', tabNm, currentTabNm}) => {
    const navigate = useNavigate();
    const handleTabClick = () => navigate(`/mypage/${tabNm}`);
    return <button className={`tab-btn ${currentTabNm === tabNm ? 'active' : ''}`}
        onClick={handleTabClick}
    >{label}</button>
}

const ProfileThumbnail = ({ src, alt }) => {
    const [show, setShow] = useState(!!src);

    useEffect(() => {
        setShow(!!src);
    }, [src]);

    if (!src || !show) return null;

    return (
        <div className="mypage-profile-widget-thumbnail">
            <img src={src} alt={alt} onError={() => setShow(false)} />
        </div>
    );
};

const MyAside = ({ user, updateUserInfo }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [contactInfo, setContactInfo] = useState({
        userExpertPhone: "",
        user_expert_kakao_id: "",
        userExpertEmail: "",
    });

    useEffect(() => {
        setContactInfo({
            userExpertPhone: user?.userExpertPhone || "",
            user_expert_kakao_id: user?.user_expert_kakao_id || "",
            userExpertEmail: user?.userExpertEmail || "",
        });
    }, [user]);

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setContactInfo((prev) => ({ ...prev, [name]: value }));
    };

    const resetContactInfo = () => {
        setContactInfo({
            userExpertPhone: user?.userExpertPhone || "",
            user_expert_kakao_id: user?.user_expert_kakao_id || "",
            userExpertEmail: user?.userExpertEmail || "",
        });
    };

    const handleEditBtn = async (e) => {
        e.preventDefault();

        if (!isEdit) {
            setIsEdit(true);
            return;
        }

        const diffData = {};
        if ((user?.userExpertPhone || "") !== contactInfo.userExpertPhone) {
            diffData.userExpertPhone = contactInfo.userExpertPhone;
        }
        if ((user?.user_expert_kakao_id || "") !== contactInfo.user_expert_kakao_id) {
            diffData.user_expert_kakao_id = contactInfo.user_expert_kakao_id;
        }
        if ((user?.userExpertEmail || "") !== contactInfo.userExpertEmail) {
            diffData.userExpertEmail = contactInfo.userExpertEmail;
        }

        if (Object.keys(diffData).length === 0) {
            setIsEdit(false);
            return;
        }

        const rslt = await UserApi.updateUserInfo(diffData);
        if (rslt?.code === "success") {
            alert("개인 정보가 변경 되었습니다.");
            updateUserInfo();
            setIsEdit(false);
            return;
        }

        alert("정보 변경에 실패하였습니다.");
        resetContactInfo();
        setIsEdit(false);
    };

    return (
        <aside className="vh-content-aside">
            <div className="vh-content-aside-rail">
                <div className="mypage-profile-widget">
                    <div className="mypage-profile-widget-inner">
                        <ProfileThumbnail src={resolveUserProfileImg(user)} />

                        <strong className="mypage-profile-widget-name">{user?.userNicknm || user?.userNm || ""}</strong>

                        <p className="mypage-profile-widget-follow">
                            팔로워 <strong>{user?.followerCnt || 0}</strong>
                        </p>

                        <dl className="mypage-profile-widget-info">
                            <div className="mypage-profile-widget-info-row">
                                <dt>전문가 연락처</dt>
                                <dd>
                                    {isEdit ? (
                                        <input
                                            type="text"
                                            className="mypage-profile-widget-info-input"
                                            name="userExpertPhone"
                                            value={contactInfo.userExpertPhone}
                                            onChange={handleFieldChange}
                                        />
                                    ) : (
                                        user?.userExpertPhone || "-"
                                    )}
                                </dd>
                            </div>
                            <div className="mypage-profile-widget-info-row">
                                <dt>카카오톡</dt>
                                <dd>
                                    {isEdit ? (
                                        <input
                                            type="text"
                                            className="mypage-profile-widget-info-input"
                                            name="user_expert_kakao_id"
                                            value={contactInfo.user_expert_kakao_id}
                                            onChange={handleFieldChange}
                                        />
                                    ) : (
                                        user?.user_expert_kakao_id || "-"
                                    )}
                                </dd>
                            </div>
                            <div className="mypage-profile-widget-info-row">
                                <dt>이메일</dt>
                                <dd>
                                    {isEdit ? (
                                        <input
                                            type="email"
                                            className="mypage-profile-widget-info-input"
                                            name="userExpertEmail"
                                            value={contactInfo.userExpertEmail}
                                            onChange={handleFieldChange}
                                        />
                                    ) : (
                                        user?.userExpertEmail || "-"
                                    )}
                                </dd>
                            </div>
                        </dl>

                        <a href="#" className="mypage-profile-widget-button" onClick={handleEditBtn}>
                            {isEdit ? "저장" : "수정"}
                        </a>
                    </div>
                </div>
            </div>
        </aside>
    );
};

const MyPage = () => {
    const { tab } = useParams();
    const { user, updateUserInfo } = useContext(UserContext);

    if (user?.isInitiative) return <div className="vh-content"></div>

    if (!user || !user.userId) {
        alert('로그인이 필요합니다.');
        sessionStorage.setItem('referrer', window.location.href);
        return <Navigate to={'/login'} replace />
    }

    return (
        <>
            <MyAside user={user} updateUserInfo={updateUserInfo} />
            <div className="vh-content"> 
                {tab === 'info' && <MyInfo />}
                {tab === 'group' && <MyGroup />}
                {tab === 'order' && <MyOrder />}
                {tab === 'point' && <MyPoint />}
                {tab === 'post' && <MyPost />}
                {tab === 'expert' && <MyExpert />}
                {tab === 'membership' && <Membership />}
            </div>
        </>
        
    )
} 

export default MyPage;
